import { render, staticRenderFns } from "./SuppliersArchived.vue?vue&type=template&id=0d75d229"
import script from "./SuppliersArchived.vue?vue&type=script&lang=js"
export * from "./SuppliersArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports